import * as React from "react";
import styled, { css } from "styled-components";
const StyledDropdownMenu = styled.ul.attrs(() => ({
  className: "dropdown-menu"
}))(
  ({ $show, theme, $zIndex, $minWidth }) => css`
    display: ${$show ? "block" : "none"};
    color: ${theme.colors.variant.dark.default};
    background-color: ${theme.colors.variant.lightest.default};
    box-shadow: 0 3px 3px ${theme.colors.global.navigationBoxShadow};
    z-index: ${$zIndex};
    min-width: ${$minWidth ? `${$minWidth}px` : "max-content"};

    .dropdown-header {
      color: ${theme.colors.variant.dark.default};
      padding: 3px 10px;
    }

    > li {
      > a {
        padding: 3px 10px;
        color: ${theme.colors.variant.darker.default};
        display: flex;
        align-items: center;

        &:hover {
          color: ${theme.colors.variant.darkest.default};
          background-color: ${theme.colors.variant.lighter.default};
        }
      }

      &.disabled {
        > a {
          color: ${theme.colors.variant.light.default};
        }
      }
    }
  `
);
function closeOnChildSelect(child, updateDepth, onMenuItemSelect) {
  var _a, _b;
  if ((_a = child.props) == null ? void 0 : _a.onSelect) {
    return {
      onSelect: (_eventKey, event) => {
        child.props.onSelect();
        onMenuItemSelect(event);
      }
    };
  }
  if ((_b = child.props) == null ? void 0 : _b.children) {
    return {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      children: closeOnChildrenSelect(child.props.children, updateDepth + 1, onMenuItemSelect)
    };
  }
  return {};
}
function closeOnChildrenSelect(children, updateDepth, onToggle) {
  const maxChildDepth = 2;
  if (updateDepth > maxChildDepth) {
    return children;
  }
  return React.Children.map(
    children,
    (child) => (child == null ? void 0 : child.props) ? React.cloneElement(child, {
      ...child.props,
      ...closeOnChildSelect(child, updateDepth + 1, onToggle)
    }) : child
  );
}
const DropdownMenu = ({
  show = false,
  children,
  zIndex = 1050,
  onMenuItemSelect = () => {
  },
  minWidth = void 0,
  ...restProps
}) => {
  const mappedChildren = closeOnChildrenSelect(children, 0, onMenuItemSelect);
  return /* @__PURE__ */ React.createElement(StyledDropdownMenu, { ...restProps, $show: show, $zIndex: zIndex, $minWidth: minWidth }, mappedChildren);
};
export default DropdownMenu;
